import React from "react";

const footer = () => {
  return (
    <div>
      <br></br>
      <br></br>
      <br></br>
    </div>
  );
};

export default footer;
